/**
 * arbi-docs route surface. BrowserRouter → AppProvider (shared root context for
 * cross-subdomain auth/role/theme) → AuthGate (any authenticated role) →
 * DocsLayout shell with four pages: Help docs (renders published docs_pages),
 * System Requirements (static browser policy), Release Notes (published
 * release_notes), Contact (static). Day 100; the DOC_STANDARDS chrome (anchor-TOC,
 * slug registry, "?" deep-links, search) is Day 100b.
 */
import { type JSX } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AppProvider } from './context/AppContext';
import AuthGate from './components/AuthGate';
import DocsLayout from './components/layout/DocsLayout';
import HelpDocs from './pages/HelpDocs';
import SystemRequirements from './pages/SystemRequirements';
import ReleaseNotes from './pages/ReleaseNotes';
import Contact from './pages/Contact';

export default function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AppProvider>
        <AuthGate>
          <Routes>
            <Route element={<DocsLayout />}>
              <Route index element={<HelpDocs />} />
              <Route path="system-requirements" element={<SystemRequirements />} />
              <Route path="release-notes" element={<ReleaseNotes />} />
              <Route path="contact" element={<Contact />} />
              <Route path="*" element={<HelpDocs />} />
            </Route>
          </Routes>
        </AuthGate>
        <Analytics />
      </AppProvider>
    </BrowserRouter>
  );
}
